import React from 'react'
import styles from './FullBleedList.scss'
import {ListMinimal} from 'common/styleguide/ListMinimal'

export const FullBleedList = ({children, expanded, interactive, ...props}) => (
  <ListMinimal interactive={interactive} expanded={expanded} className={styles.FullBleedList} {...props}>
    {children}
  </ListMinimal>
)

FullBleedList.defaultProps = {
  interactive: true
}
